import { Model } from 'app/model/backendmodel';
import { OwnedSet, UserProperty } from 'shell-models-lib';

export class ActivityUserPropertiesAdapter {
    public toResource(userProperties: OwnedSet<UserProperty>): Model.ActivityUserProperty[] {
        const modelUserProperties: Model.ActivityUserProperty[] = [];
        userProperties.forEach((userProperty: UserProperty) => {
            modelUserProperties.push({
                name: userProperty.name,
                value: userProperty.value
            });
        });
        return modelUserProperties;
    }

    public toModel(modelUserProperties: Model.ActivityUserProperty[]): Set<UserProperty> {
        const userProperties = new Set<UserProperty>();

        modelUserProperties.forEach((element) => {
            const activityUserProperty = new UserProperty();
            activityUserProperty.name = element.name;
            activityUserProperty.value = element.value;

            userProperties.add(activityUserProperty);
        });

        return userProperties;
    }

}
